import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-ink text-white">
      {/* Top divider line */}
      <div className="h-px bg-white/8 mx-8 md:mx-14 lg:mx-20" />

      <div className="mx-auto px-8 md:px-14 lg:px-20 py-16 md:py-20">

        {/* Brand name — large editorial */}
        <div className="mb-14 md:mb-16">
          <Link to="/" className="heading-display text-white text-[clamp(2.2rem,5vw,4rem)] leading-none">
            George &amp; Co.
          </Link>
          <p className="label-sm text-white/60 mt-3">
            Wedding Photography &amp; Videography · Est. 2019
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8 mb-14 md:mb-16">

          {/* Services */}
          <div>
            <p className="label-sm text-white/60 mb-5">Services</p>
            <ul className="space-y-3">
              {['Wedding Photography', 'Wedding Videography', 'Engagement Sessions', 'Corporate'].map(s => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="label-sm text-white/65 hover:text-white/80 transition-colors duration-300"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigate */}
          <div>
            <p className="label-sm text-white/60 mb-5">Navigate</p>
            <ul className="space-y-3">
              {[
                { to: '/gallery',      label: 'Work' },
                { to: '/services',     label: 'Services' },
                { to: '/testimonials', label: 'Stories' },
                { to: '/contact',      label: 'Contact' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="label-sm text-white/65 hover:text-white/80 transition-colors duration-300"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="label-sm text-white/60 mb-5">Contact</p>
            <div className="space-y-3">
              <a
                href="mailto:info@georgeandco.co.za"
                className="label-sm text-white/65 hover:text-white/80 transition-colors duration-300 block break-all"
              >
                info@georgeandco.co.za
              </a>
              <p className="label-sm text-white/60">Pretoria, South Africa</p>
              <p className="label-sm text-white/60">Available Worldwide</p>
            </div>
          </div>

          {/* Social */}
          <div>
            <p className="label-sm text-white/60 mb-5">Follow</p>
            <div className="space-y-3">
              <a
                href="https://www.instagram.com/georgeandco.co.za"
                target="_blank"
                rel="noopener noreferrer"
                className="label-sm text-white/65 hover:text-white/80 transition-colors duration-300 block"
              >
                Instagram
              </a>
              <a
                href="https://www.facebook.com/georgeandco.co.za"
                target="_blank"
                rel="noopener noreferrer"
                className="label-sm text-white/65 hover:text-white/80 transition-colors duration-300 block"
              >
                Facebook
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/8 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <p className="label-sm text-white/60">
            &copy; {new Date().getFullYear()} George &amp; Co. All rights reserved.
          </p>
          <p className="label-sm text-white/60">
            Preserving love stories since 2019
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
